





















































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { Variant, VariantType } from '~/models/app/variant'

export default defineComponent({
  props: {
    value: { type: Number, default: 0 },
    variant: {
      type: String as PropType<VariantType>,
      default: Variant.PRIMARY
    },
    showProgress: { type: Boolean, default: false },
    progressPositionRight: { type: Boolean, default: false },
    linear: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    animated: { type: Boolean, default: false },
    progressClass: { type: [String, Array], default: null }
  },
  setup(props) {
    const { variant, value } = toRefs(props)

    const pBarRef = ref<HTMLElement | null>(null)

    const variantBgColor = computed(() => {
      switch (variant.value) {
        case Variant.SECONDARY: {
          return 'tw-bg-grey-700'
        }
        case Variant.INFO: {
          return 'tw-bg-sky'
        }
        case Variant.SUCCESS: {
          return 'tw-bg-green'
        }
        case Variant.WARNING: {
          return 'tw-bg-yellow'
        }
        case Variant.DANGER: {
          return 'tw-bg-red'
        }
        case Variant.WHITE: {
          return 'tw-bg-white'
        }
        case Variant.LIGHT: {
          return 'tw-bg-grey-300'
        }
        case Variant.PRIMARY:
        default: {
          return 'tw-bg-primary'
        }
      }
    })
    const variantTextColor = computed(() => {
      if (variant.value === Variant.WHITE) {
        return 'text-current'
      } else if (variant.value === Variant.LIGHT) {
        return 'tw-text-grey-700'
      }
      return 'tw-text-white'
    })

    const progressStyle = computed(() => {
      function width() {
        if (value.value > 100) {
          return '100%'
        }
        return `${value.value}%`
      }
      return {
        width: width()
      }
    })

    return {
      pBarRef,
      variantBgColor,
      variantTextColor,
      progressStyle
    }
  }
})
